import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { HttpClientService } from '../../lib/http/http-client.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CommonService {
  public AuthUser = new BehaviorSubject(null);
  public Buyer = new BehaviorSubject(null);
  public serviceRequestFileCount = new BehaviorSubject(null);
  public serviceRequestFileType = new BehaviorSubject(null);
  public serviceRequestImageSizePerFile = new BehaviorSubject(null);
  public serviceRequestVideoSizePerFile = new BehaviorSubject(null);
  public CommunityLotPictureSizePerFile = new BehaviorSubject(null);
  constructor(public http: HttpClientService) {

  }

  setAuthUser(obj) {
    this.AuthUser.next(obj); //new Observable(observer => observer.next(obj));
  }
  public getCurrentBuyerDetails() {
    return this.http.get('/DashBoard/GetCurrentBuyerDetails');
  }

  public GetCityByStateId(StateId: number) {
    return this.http.get('/DashBoard/GetCityListByStateId?StateID=' + StateId);
  }

  public GetStateByCountryId(CountryId: number) {
    return this.http.get('/DashBoard/GetStateListByCountryId?CountryID=' + CountryId);
  }

  public getServiceRequestFileConfig(key: string) {
    return this.http.get('/ServiceRequest/GetServiceRequestFileConfig?KeyName=' + key);
  }

  public getDisclosureMessageFromConfig() {
    return this.http.get('/Sales/GetDisclosureMessageFromConfig');
  }

  refreshToken(): Observable<Object> {
    /*
        The call that goes in here will use the existing refresh token to call
        a method on the oAuth server (usually called refreshToken) to get a new
        authorization token for the API calls.
    */
    let body = "grant_type=refresh_token&refresh_token=" + localStorage.getItem('refresh_token') + "&client_id=";
    let headers: any = {};
    headers['Content-Type'] = 'application/x-www-form-urlencoded';
    return this.http.post('/token', body, headers);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/common.service.ts